import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCaseSplit',
})
export class CamelCaseSplitPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (typeof value !== 'string') {
      return value;
    }
    value = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    return value;
  }
}
